import React, {Suspense, useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import classNames from "classnames/bind";
import {useGetStudioMode} from "components/Layout/hooks";
import AssetTab from "components/AssetTab";
import ScriptTab from "components/ScriptTab";
import AssetLayer from "components/AssetLayer";
import MyTab from "components/MyTab";
import FavoritesTab from "components/FavoritesTab";
import {MENU, SEARCH_PARAMS} from "../../constants";
import SideMenu from "./SideMenu";
import {codeMenuList, worldMenuList} from "./menus";
import UploadProgressProvider from "./UploadProgressProvider";
import Spinner from "./fallbacks/Spinner";
import MoreAsset from "./MoreAsset";
import ModelTab from "./ModelTab";
import SearchTab from "./SearchTab";
import SearchBar from "./SearchBar";
import styles from "./index.module.scss";
import {useDispatch} from "react-redux";
import {setCurrentSearchParams} from "store/actions/assetLibrary";

const cn = classNames.bind(styles);

function ObjectPanel({isCodeMode, isObjectPanelOpen, handleObjectPanel}) {
  const {isEditMode} = useGetStudioMode();
  const [searchParams, setSearchParams] = useSearchParams({
    [SEARCH_PARAMS.TAB]: isCodeMode ? MENU.SCRIPT : MENU.MODEL,
  });

  const currentType = searchParams.get(SEARCH_PARAMS.TYPE);
  const currentTab = searchParams.get(SEARCH_PARAMS.TAB);
  const hasSearchBar = currentTab === MENU.MODEL;
  // 후에 ASSET TAB에서 검색기능 다시 추가
  // const hasSearchBar = currentTab === MENU.MODEL || currentTab === MENU.ASSET;
  const searchKeyword = searchParams.get(SEARCH_PARAMS.SEARCH);
  const isSearchTabOpen = searchParams.has(SEARCH_PARAMS.SEARCH) && searchKeyword !== "" && hasSearchBar;
  const dispatch = useDispatch();
  const handleSelectedMenu = menu => {
    searchParams.set(SEARCH_PARAMS.TAB, menu);
    searchParams.delete(SEARCH_PARAMS.TYPE);
    setSearchParams(searchParams);
    if (!isObjectPanelOpen) handleObjectPanel();
    dispatch(setCurrentSearchParams({}));
  };

  useEffect(() => {
    searchParams.set(SEARCH_PARAMS.TAB, isCodeMode ? MENU.SCRIPT : MENU.MODEL);
    searchParams.delete(SEARCH_PARAMS.TYPE);
    setSearchParams(searchParams);
  }, [isCodeMode]);

  const sections = {
    [MENU.ASSET]: <AssetTab />,
    [MENU.LAYER]: <AssetLayer />,
    [MENU.MY]: (
      <UploadProgressProvider>
        <MyTab />
      </UploadProgressProvider>
    ),
    [MENU.MODEL]: <ModelTab />,
    [MENU.SCRIPT]: <ScriptTab />,
    [MENU.FAVORITES]: <FavoritesTab />,
  };

  const sectionName = {
    [MENU.ASSET]: "Asset",
    [MENU.MY]: "My",
    [MENU.MODEL]: "Model",
    [MENU.FAVORITES]: "Favorites",
  };

  return (
    <section className={cn("container", !isEditMode ? "closed_all" : !isObjectPanelOpen && "closed_section")}>
      <SideMenu menus={isCodeMode ? codeMenuList : worldMenuList} selectedMenu={currentTab} handleSelectedMenu={handleSelectedMenu} />
      {isObjectPanelOpen && (
        <div className={styles.section_container}>
          {sectionName[currentTab] && <header className={styles.header}>{sectionName[currentTab]}</header>}
          {isEditMode && hasSearchBar && (
            <div className={styles.search_bar}>
              <SearchBar searchKeyword={searchKeyword} />
            </div>
          )}

          {isSearchTabOpen ? (
            <SearchTab searchKeyword={searchKeyword} />
          ) : currentType ? (
            <Suspense fallback={<Spinner />}>
              <MoreAsset />
            </Suspense>
          ) : (
            <Suspense fallback={<Spinner />}>{sections[currentTab]}</Suspense>
          )}
        </div>
      )}
    </section>
  );
}

export default React.memo(ObjectPanel);
